'use client'

import { SentenceMakingQuestion } from '@entities/lesson'
import { clsx } from 'clsx'

import { Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: SentenceMakingQuestion
  userAnswer: string[]
  masterAnswer: string[]
  aiExplanation: string
  masterHighlight: number[]
}

export const WrongSentenceMakingToastDescription = ({
  userAnswer,
  masterAnswer,
  aiExplanation,
  masterHighlight,
}: Props) => {
  return (
    <VStack className="gap-4">
      <VStack className="gap-0.5">
        <Typography size="h6" className="font-medium text-white">
          {userAnswer.map((part, index, origin) => {
            const isLastIndex = index === origin.length - 1

            return <span key={`userAnswer-${part}`}>{`${part}${isLastIndex ? '' : ' '}`}</span>
          })}
        </Typography>
        <Typography size="h6" className="font-medium text-white">
          {masterAnswer.map((part, index, origin) => {
            const isMasterAnswerPart = masterHighlight.includes(index)
            const isLastIndex = index === origin.length - 1

            return (
              <span key={`masterAnswer-${part}`} className={clsx(isMasterAnswerPart ? 'text-blue-normal' : '')}>
                {`${part}${isLastIndex ? '' : ' '}`}
              </span>
            )
          })}
        </Typography>
      </VStack>
      <Typography size="h6" className="font-medium text-gray-400">
        {aiExplanation}
      </Typography>
    </VStack>
  )
}
